import React from "react";
import { useRef } from "react";
import { Form, Divider, Input, DatePicker, Button, Upload } from 'antd';
import { UploadOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons";
const { TextArea } = Input;


const TechnicalReviewers = () => {
    const technicalReviewerAddButtonRef = useRef(null);
    return (
        <div className="col-lg-12 col-md-12">
            <Form.List name="technical_reviewers">
                {(technicalReviewers, { add, remove }) => {
                    if (technicalReviewers.length == 0 && technicalReviewerAddButtonRef.current) {
                        technicalReviewerAddButtonRef.current.click();
                    }
                    return (
                        <div>
                            {technicalReviewers.map((field, index) =>
                                <div key={field.key} className="row">

                                    {technicalReviewers.length > 1 &&
                                        (<div className="col-lg-12 col-md-12" style={{ display: 'flex', justifyContent: "space-between", alignItems: "center", background: "#d3d3d34a", marginBottom: "15px" }}>
                                            <div>
                                                #{index + 1}
                                            </div>
                                            {technicalReviewers.length > 1 &&
                                                <Button
                                                    type="link"
                                                    className="dynamic-delete-button"
                                                    onClick={() => { remove(field.name) }}
                                                    icon={<DeleteOutlined style={{ color: "red" }} />}
                                                >
                                                </Button>
                                            }
                                        </div>)}
                                    <div className="col-lg-6 col-md-12">
                                        <Form.Item
                                            name={[index, "technical_users"]}
                                            label="Reviewer"
                                            rules={[{ required: true, message: "Please enter Reviewer" }]}>
                                            <Input placeholder="Enter Reviewer" />
                                        </Form.Item>
                                    </div>
                                </div>
                            )}
                            <Divider />
                            <div className="row">
                                <div className="col-lg-12 col-md-12" style={{textAlign: "right"}}>
                                    <Form.Item>
                                        <Button
                                            ref={technicalReviewerAddButtonRef}
                                            type="primary"
                                            onClick={() => add()}
                                        >
                                            <PlusOutlined />
                                            {technicalReviewers.length > 0 ? "Add more" : "Add"}
                                        </Button>
                                    </Form.Item>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </Form.List>
        </div>
    )
}

export default TechnicalReviewers;